<template>
  <transition name="modal">
    <div class="modal" tabindex="-1" v-show="show">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <button type="button" class="close position-absolute" @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="service-content p-4">
            <h3 class="mb-4">法律意见咨询</h3>
            <form @submit.prevent="submitForm">
              <div class="form-group mb-3">
                <label class="form-label">咨询类型</label>
                <select v-model="formData.type" class="form-control" required>
                  <option value="">请选择咨询类型</option>
                  <option value="labor">普通劳动纠纷</option>
                  <option value="civil">普通民事纠纷</option>
                  <option value="other">其他法律建议</option>
                </select>
              </div>

              <div class="form-group mb-3">
                <label class="form-label">问题描述</label>
                <textarea 
                  v-model="formData.description" 
                  class="form-control" 
                  rows="3"
                  placeholder="请详细描述您的法律问题"
                  required
                ></textarea>
              </div>

              <div class="form-group mb-3">
                <label class="form-label">联系人姓名</label>
                <input 
                  type="text" 
                  v-model="formData.custName" 
                  class="form-control"
                  placeholder="请输入您的姓名"
                  required
                >
              </div>

              <div class="form-group mb-3">
                <label class="form-label">电子邮箱</label>
                <input 
                  type="email" 
                  v-model="formData.email" 
                  class="form-control"
                  placeholder="请输入您的电子邮箱"
                  required
                >
              </div>

              <div class="form-group mb-4">
                <label class="form-label">网站声明</label>
                <p class="small text-muted extra-small-text">本网站所提供的法律咨询服务为公益性质，均属免费项目。如您遇到收费情况，请立即终止交易并与本网站取得联系。此外，如需起诉、应诉服务，请通过正规途径寻求律师帮助。</p>
                <p class="small text-muted">请手动输入：我已知悉本网站的法律咨询服务的性质并自愿遵守其服务规则。因违反服务规则或国家法律法规所造成的损失，由本人承担。</p>
                <textarea 
                  v-model="formData.acknowledgement" 
                  class="form-control" 
                  rows="3"
                  required
                  @paste.prevent
                ></textarea>
              </div>

              <button type="submit" class="btn btn-primary w-100">确认提交</button>
            </form>
          </div>
        </div>
      </div>
      <div class="modal-backdrop" @click="$emit('close')"></div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'LegalServiceModal',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {
        type: '',
        description: '',
        name: '',
        email: '',
        acknowledgement: ''
      }
    }
  },
  methods: {
    showToast(type, message) {
      // 修改toast的调用方式
      if (type === 'success') {
        this.$toast.success(message);
      } else if (type === 'error') {
        this.$toast.error(message);
      }
    },
    submitForm() {
      this.$http.post('/legal/service-form', this.formData)
        .then(() => {
          this.showToast('success', '提交成功！我们会尽快与您联系');
          // $('#legalServiceModal').modal('hide');
          this.$emit('close');
        })
        .catch(error => {
          // const errorMsg = error.response?.data?.message || '提交失败，请稍后再试';
          const errorMsg = error.response && error.response.data && error.response.data.message || '提交失败，请稍后再试';
          this.showToast('error', errorMsg);
          console.error('提交表单失败:', error);
        });
    }
  }
};
</script>

<style scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-dialog {
  max-width: 500px;
  width: 100%;
  margin: 1.75rem;
  position: relative;
  pointer-events: auto;
}

.modal-content {
  position: relative;
  width: 100%;
  border: none;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  background-color: #fff;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: -1;
}

.close {
  right: 1rem;
  top: 1rem;
  z-index: 1050;
  color: #000;
  opacity: 0.5;
  transition: opacity 0.2s;
  background: none;
  border: none;
  font-size: 1.5rem;
}

.close:hover {
  opacity: 1;
}

.form-label {
  font-weight: 500;
  color: #2c3e50;
  margin-bottom: 0.5rem;
}

.btn-primary {
  background-color: #3498db;
  border-color: #3498db;
}

.btn-primary:hover {
  background-color: #2980b9;
  border-color: #2980b9;
}

.extra-small-text {
  font-size: 11px;
}

/* 动画相关样式 */
.modal-enter-active,
.modal-leave-active {
  transition: all 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-dialog,
.modal-leave-to .modal-dialog {
  transform: translateY(-60px);
}

.modal-enter-to .modal-dialog,
.modal-leave-from .modal-dialog {
  transform: translateY(0);
}
</style>